import {
  GetStaticProps,
  GetStaticPropsContext,
  InferGetStaticPropsType,
  NextPage,
} from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  LegalNoticeDocument,
  LegalNoticeQuery,
  LegalNoticeQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import EnhancedPolicyPageWrapper from '@/components/policies/EnhancedPolicyPageWrapper';
import { Seo } from '@/components/Seo';

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext,
) => {
  const client = initializeApollo();
  const { locale } = context;

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: FooterDocument });
  await client.query({ query: LegalNoticeDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument, variables: { locale: locale || 'en' } });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument, variables: { locale: locale || 'en' } });

  const { data: legalNoticeData } = await client.query<
    LegalNoticeQuery,
    LegalNoticeQueryVariables
  >({
    query: LegalNoticeDocument,
    variables: { locale: locale || 'en' },
  });

  return addApolloState(client, {
    props: {
      footerData,
      headerData,
      legalNoticeData,
    },
  });
};

const LegalNotice: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  footerData,
  headerData,
  legalNoticeData,
}) => (
  <Layout invertedColor footerData={footerData} headerData={headerData}>
    <Seo seo={legalNoticeData.legalNotice?.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={legalNoticeData.legalNotice?.data?.attributes?.legalNotice}
    />
  </Layout>
);

export default LegalNotice;
